module.exports = __webpack_public_path__ + "img/incendie.5f91daa8.jpg";